/**
 * Class for test Dispatcher Select Organization List.
 *
 */


Greenmile.DispatcherSelectOrganizationList = (function () {

    function DispatcherSelectOrganizationList () {

        Greenmile.OrganizationListBase.apply(this, arguments);

        this.afterClickOnCheckBox = function (rowList, status) {

            var children = rowList.querySelectorAll('li');
            var id = rowList.getAttribute('organizationId');
            var checkAllParentNodes = function (context) {
                return function () {
                    var parent = rowList.parentNode;
                    while (parent.tagName === 'LI') {
                        parent.querySelector('input[type="checkbox"]').checked = status;
                        context.updateStatusOnData(context.data, parent.getAttribute('organizationId'), status);
                        parent = parent.parentNode;
                    }
                };
            }(this);
            var checkAllChildren = function (context) {
                return function () {
                    for (var i = 0, j = children.length; i < j; i++) {
                        children[i].querySelector('input[type="checkbox"]').checked = status;
                        context.updateStatusOnData(context.data, children[i].getAttribute('organizationId'), status);
                    }
                };
            }(this);

            this.updateStatusOnData(this.data, id, status);

            if (status && !children.length) {
                checkAllParentNodes();
            } else if (status) {
                checkAllChildren();
                checkAllParentNodes();
            } else {
                checkAllChildren();
            }

        };

        this.updateStatusOnData = function (data, id, status) {

            for (var key in data) {

                var item = data[key];

                if (item.childOrganizations) {
                    this.updateStatusOnData(item.childOrganizations, id, status);
                }

                if (item.organization.id === parseInt(id)) {
                    item.hasVisibility = Boolean(status);
                    break;
                }

            }

        };

        this.getValue = function () {
            let childs;

            const hasVisibility = function (item) {
                return item.hasVisibility;
            };

            const formatToMap = function (item) {
                return {
                    id: item.organization.id
                };
            };

            const getChecked = function (item) {

                if (item.childOrganizations) {
                    childs = item.childOrganizations.filter(getChecked).map(formatToMap).concat(childs);
                }

                return hasVisibility(item);
            };

            childs = [];
            const listOrganizationChecked = this.data.filter(getChecked).map(formatToMap).concat(childs);

            return listOrganizationChecked;

        };

    }

    return DispatcherSelectOrganizationList;

}());
